import liveCheckReducerMap from 'wanderu-ducks-live-check';
import psearchReducerMap from 'wanderu-ducks-psearch';
import seoReducerMap from 'wanderu-ducks-seo';

import MultiModalCityToCity from '../containers/MultiModalCityToCity/MultiModalCityToCity';

function onLoad(module, info, props, context) {
    context.store.inject({
        ...seoReducerMap,
        ...psearchReducerMap,
        ...liveCheckReducerMap,
    });
}

export { onLoad };
export default MultiModalCityToCity;
